import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import frontGuard from './front-guard'
import postGuard from './post-guard'
const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {
  console.log('push', location)
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter)
const router = new VueRouter({
  base: Vue.prototype.$qiankun ? 'app-base-contract-fe' : '',
  mode: 'history',
  routes
})

router.beforeEach(frontGuard)
router.afterEach(postGuard)

export default router
